import React from 'react';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { ShareLinkFieldType } from '../link-config-form.factory';
import { AliasCustomFieldType } from 'src/common/interfaces/journey/alias.interface';

interface Props {
  customFields: AliasCustomFieldType[];
  onFieldChange: <T>(payload: ShareLinkFieldType<T>) => void;
}

export const ShareCustomFields = ({ customFields, onFieldChange }: Props) => {

  const hasCustomField = (field: string) => {
    return customFields.some((cf) => cf.field === field);
  };

  const getUpdatedCustomFields = (customField: AliasCustomFieldType, enabled: boolean) => {
    // check if field is in customFields first as a key
    // if not then add it
    const { field } = customField;
    const hasField = hasCustomField(field);

    if (enabled) {
      // automatically enable email_required field if any of the custom fields are enabled.
      onFieldChange({ field: 'email_required', value: true });

      if (!hasField) return customFields.concat(customField);

      return customFields.map((cf) => {
        if (cf.field === field) return customField;
        return cf;
      });
    } else {
      if (!hasField) return customFields;

      return customFields.filter((cf) => cf.field !== field);
    }
  };

  const onNameRequiredToggleChanged = (value: boolean) => {
    const nameField: AliasCustomFieldType = {
      field: 'full_name',
      label: 'Full Name',
      type: 'string',
    };

    const customFields = getUpdatedCustomFields(nameField, value);
    onFieldChange({ field: 'custom_fields', value: customFields });
  };

  const onPhoneRequiredToggleChanged = (value: boolean) => {
    const phoneNumberField: AliasCustomFieldType = {
      field: 'phone_number',
      label: 'Phone Number',
      type: 'string',
    };
    const customFields = getUpdatedCustomFields(phoneNumberField, value);
    onFieldChange({ field: 'custom_fields', value: customFields });
  };

  const onCompanyNameRequiredToggleChanged = (value: boolean) => {
    const companyNameField: AliasCustomFieldType = {
      field: 'company_name',
      label: 'Company Name',
      type: 'string',
    };

    const customFields = getUpdatedCustomFields(companyNameField, value);
    onFieldChange({ field: 'custom_fields', value: customFields });
  };

  return (
    <div className='flex flex-col space-y-6'>
      <div className='text-bedrock-p-small'>
        Enabling any of the custom fields below will automatically require viewers to enter their email address before
        they can view the journey.
      </div>
      <div>
        <div className='flex flex-col space-y-sm'>
          <ToggleComponent
            groupClassName='flex-1'
            checked={hasCustomField('full_name')}
            onChange={onNameRequiredToggleChanged}
            label='Require name'
            labelType='strong'
          />
          <div className='text-bedrock-p-small text-bedrock-black'>Viewers will be asked their names.</div>
        </div>
      </div>
      <div>
        <div className='flex flex-col space-y-sm'>
          <ToggleComponent
            groupClassName='flex-1'
            checked={hasCustomField('company_name')}
            onChange={onCompanyNameRequiredToggleChanged}
            label='Require company name'
            labelType='strong'
          />
          <div className='text-bedrock-p-small text-bedrock-black'>Viewers will be asked their company names.</div>
        </div>
      </div>
      <div>
        <div className='flex flex-col space-y-sm'>
          <ToggleComponent
            groupClassName='flex-1'
            checked={hasCustomField('phone_number')}
            onChange={onPhoneRequiredToggleChanged}
            label='Require phone number'
            labelType='strong'
          />
          <div className='text-bedrock-p-small text-bedrock-black'>Viewers will be asked their phone number.</div>
        </div>
      </div>
    </div>
  );
};
